<template>
  <section class="amii-voice-showcase py-5 bg-white border-top border-bottom">
    <div class="container">
      <div class="row align-items-center">
        <!-- Text Column -->
        <div class="col-lg-6 mb-4 mb-lg-0 text-left">
          <span
            class="badge badge-success-light text-success-dark
                       font-weight-bold px-3 py-2 text-uppercase mb-2"
          >
            🎙️ AMII Voz & Dictado Inteligente
          </span>
          <h2 class="h1 font-weight-bold text-dark-blue mb-3">
            Tú conversas con el paciente, AMII toma las notas por ti.
          </h2>
          <p class="lead text-muted mb-4">
            Activa la escucha activa durante la consulta. Dicta los
            parámetros o deja que la IA organice el motivo de
            consulta, examen físico e indicaciones en el borrador de
            la historia clínica.
          </p>

          <div class="card p-3 bg-light border-0 rounded-lg mb-3">
            <div class="d-flex align-items-center">
              <div class="rounded-circle bg-primary-base text-white p-3 mr-3">
                <font-awesome-icon
                  icon="file-alt"
                  size="lg"
                />
              </div>
              <div>
                <h4 class="h6 font-weight-bold mb-1 text-dark">
                  Recipes e Informes en 1 Clic
                </h4>
                <p class="small text-muted mb-0">
                  Personaliza tus plantillas y mantén tu identidad
                  corporativa con logo, membrete y firma digital.
                </p>
              </div>
            </div>
          </div>

          <button
            class="btn btn-success-base btn-pulse-success px-4 py-2
                   font-weight-bold rounded-lg"
            @click="$emit('start-register')"
          >
            Probar AMII Voz Gratis →
          </button>
        </div>

        <!-- Animated Wave / Graphic Simulation Column -->
        <div class="col-lg-6">
          <div
            class="card p-4 rounded-xl shadow-lg
                      border-primary-light bg-dark-blue text-white"
          >
            <div
              class="d-flex align-items-center justify-content-between mb-3
             border-bottom border-secondary pb-2"
            >
              <div class="d-flex align-items-center">
                <span class="text-danger mr-2">🔴</span>
                <span class="font-weight-bold small">
                  Escucha Activa de Consulta
                </span>
              </div>
              <span class="badge badge-success-base">IA Procesando</span>
            </div>

            <!-- Simulated Waveform -->
            <div
              class="voice-showcase-image mb-3"
            >
              <img
                src="/img/amiivoz.png"
                alt="AMII Voz"
                class="img-fluid rounded-lg shadow-sm"
              >
            </div>

            <div
              class="soundwave-bar d-flex align-items-center
             justify-content-center py-3 mb-3"
            >
              <div class="bar" />
              <div class="bar" />
              <div class="bar" />
              <div class="bar" />
              <div class="bar" />
            </div>

            <!-- Realtime Transcript Box -->
            <div
              class="transcript-box bg-dark-subtle p-3 rounded
             text-left small font-monospace text-light mb-2"
            >
              <div class="text-success-light font-weight-bold mb-1">
                ▶ AMII Transcripción Automática:
              </div>
              <p class="mb-0">
                "Paciente refiere cefalea de 3 días de evolución. Se
                prescribe Paracetamol 500mg cada 8 horas por 5 días
                e hidratación abundante..."
              </p>
            </div>

            <div
              class="d-flex align-items-center justify-content-between
            mt-3 x-small text-muted"
            >
              <span>✔ Generando Récipe Digital</span>
              <span>✔ Sincronizando con App Paciente</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AmiiVoiceShowcase',
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.badge-success-light {
  background-color: #d1f2e2;
}
.text-success-dark {
  color: #02592d;
}
.bg-dark-blue {
  background-color: #00186b;
}
.bg-dark-subtle {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.text-success-light {
  color: #51f5a5;
}
.soundwave-bar .bar {
  width: 6px;
  height: 24px;
  background-color: #04c06c;
  margin: 0 4px;
  border-radius: 3px;
  animation: soundwave 1.2s infinite ease-in-out;
}
.soundwave-bar .bar:nth-child(2) { animation-delay: 0.2s; height: 38px; }
.soundwave-bar .bar:nth-child(3) { animation-delay: 0.4s; height: 50px; }
.soundwave-bar .bar:nth-child(4) { animation-delay: 0.1s; height: 30px; }
.soundwave-bar .bar:nth-child(5) { animation-delay: 0.3s; height: 18px; }

@keyframes soundwave {
  0%, 100% { transform: scaleY(0.4); }
  50% { transform: scaleY(1.2); }
}
</style>
